import {Component, OnInit, HostListener} from '@angular/core';
import {CpcWebApiService} from './cpc-web-api.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  constructor(private webapi: CpcWebApiService) {
  }

  ngOnInit(): void {

  }

}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/app.component.ts